// extracted by mini-css-extract-plugin
export default {"text1":"ImageHeaderColumns_text1__ihZxp"};